/* Account Gift Cards — load the signed-in customer's gift cards.
 *
 * Liquid can't list a customer's gift cards, so this fetches them from the
 * Velvety App Proxy Worker (/apps/velvety/account/gift-cards), which reads
 * them via the Admin API for the verified logged_in_customer_id. The Admin
 * gift-card object only exposes the last characters (never the full code),
 * so this is a balance/status overview.
 */
(function () {
  var root = document.querySelector('[data-velvety-gift-cards]');
  if (!root) return;

  function money(m) {
    if (!m || m.amount == null) return '';
    var amt = parseFloat(m.amount);
    var val = isNaN(amt) ? m.amount : amt.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (m.currencyCode ? m.currencyCode + ' ' : '') + val;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fmtDate(d) {
    if (!d) return '';
    try { return new Date(d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }); }
    catch (e) { return d; }
  }

  function emptyState() {
    return '<div class="velvety-gift-cards__empty">' +
      '<p class="velvety-gift-cards__empty-text">You don’t have any gift cards yet.</p>' +
      '<p class="velvety-gift-cards__empty-sub">Gift cards you purchase or receive will appear here with their balance.</p>' +
      '</div>';
  }

  function cardHtml(gc) {
    var active = gc.enabled && (parseFloat(gc.balance && gc.balance.amount) > 0);
    var status = active ? 'Active' : (gc.enabled ? 'No balance' : 'Disabled');
    var statusClass = active ? 'is-active' : 'is-inactive';
    var expiry = gc.expiresOn ? '<p class="velvety-gift-cards__meta">Expires ' + esc(fmtDate(gc.expiresOn)) + '</p>' : '<p class="velvety-gift-cards__meta">No expiry</p>';
    return '<article class="velvety-gift-cards__card">' +
      '<div class="velvety-gift-cards__card-head">' +
        '<span class="velvety-gift-cards__label">Gift card</span>' +
        '<span class="velvety-gift-cards__status ' + statusClass + '">' + esc(status) + '</span>' +
      '</div>' +
      '<p class="velvety-gift-cards__balance">' + esc(money(gc.balance)) + '</p>' +
      (gc.initialValue ? '<p class="velvety-gift-cards__meta">Original value ' + esc(money(gc.initialValue)) + '</p>' : '') +
      (gc.lastCharacters ? '<p class="velvety-gift-cards__code">•••• ' + esc(gc.lastCharacters) + '</p>' : '') +
      expiry +
    '</article>';
  }

  function render(html) { root.innerHTML = html; }

  fetch('/apps/velvety/account/gift-cards', { credentials: 'same-origin', cache: 'no-store' })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (!data || !data.ok) {
        render('<p class="velvety-gift-cards__error">' + esc((data && data.message) || 'Could not load your gift cards.') + '</p>');
        return;
      }
      var cards = data.gift_cards || [];
      if (!cards.length) { render(emptyState()); return; }
      render('<div class="velvety-gift-cards__grid">' + cards.map(cardHtml).join('') + '</div>');
    })
    .catch(function () {
      render('<p class="velvety-gift-cards__error">Network error. Please refresh to try again.</p>');
    });
})();
